import React from "react";

import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AddIcon from "@mui/icons-material/Add";
import AddHomeIcon from "@mui/icons-material/AddHome";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ClearIcon from "@mui/icons-material/Clear";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import EditIcon from "@mui/icons-material/Edit";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import HistoryIcon from "@mui/icons-material/History";
import InfoIcon from "@mui/icons-material/Info";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PrintIcon from "@mui/icons-material/Print";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import UndoIcon from "@mui/icons-material/Undo";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { Tooltip } from "@mui/material";

export const icons = {
  DissociateIcon: (props) => (
    <LinkOffIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  EditIcon: (props) => (
    <EditIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  DeleteIcon: (props) => (
    <DeleteIcon
      className="red"
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  AddIcon: (props) => (
    <AddIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  PriorityHighIcon: (props) => (
    <PriorityHighIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  DownloadIcon: (props) => (
    <DownloadIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  VisibilityIcon: (props) => (
    <VisibilityIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  MoreVertIcon: (props) => (
    <MoreVertIcon sx={{ cursor: "pointer", color: "black" }} {...props} />
  ),
  QuestionMarkIcon: (props) => (
    <QuestionMarkIcon sx={{ cursor: "pointer", color: "gray" }} {...props} />
  ),
  HistoryIcon: (props) => (
    <HistoryIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  PredomIcon: (props) => (
    <AddHomeIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  SearchIcon: (props) => (
    <SearchIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  AccessTimeFilledIcon: (props) => (
    <AccessTimeFilledIcon
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  MoreTimeIcon: (props) => (
    <MoreTimeIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  AccountBalanceIcon: (props) => (
    <AccountBalanceIcon
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  CloseIcon: (props) => (
    <CloseIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  DriveFileRenameOutlineIcon: (props) => (
    <DriveFileRenameOutlineIcon
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  FactCheckIcon: (props) => (
    <FactCheckIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ClearAllIcon: (props) => (
    <ClearAllIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  InfoIcon: (props) => (
    <InfoIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ReceiptIcon: (props) => (
    <ReceiptIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ClearIcon: (props) => (
    <ClearIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  SystemUpdateAltIcon: (props) => (
    <SystemUpdateAltIcon
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  PrintIcon: (props) => (
    <PrintIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ElectricBoltIcon: (props) => (
    <ElectricBoltIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  GraphicEqIcon: (props) => (
    <GraphicEqIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  UndoIcon: (props) => (
    <UndoIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  SendIcon: (props) => (
    <SendIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  QrCode2Icon: (props) => (
    <QrCode2Icon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ContentCopyIcon: (props) => (
    <ContentCopyIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  CreditCardIcon: (props) => (
    <CreditCardIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ArrowDropUpIcon: (props) => (
    <ArrowDropUpIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  ArrowDropDownIcon: (props) => (
    <ArrowDropDownIcon
      sx={{ cursor: "pointer", color: "#242B59" }}
      {...props}
    />
  ),
  MailOutlineIcon: (props) => (
    <MailOutlineIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  LockOutlinedIcon: (props) => (
    <LockOutlinedIcon sx={{ cursor: "pointer", color: "#242B59" }} {...props} />
  ),
  FacebookOutlinedIcon: (props) => (
    <FacebookOutlinedIcon
      sx={{ cursor: "pointer", color: "#0866FF" }}
      {...props}
    />
  ),
};

export const TSIcon = (props) => {
  const { icon, tooltip, ...otherprops } = props;
  if (!!tooltip) {
    return <Tooltip title={tooltip}>{icons[icon](otherprops)}</Tooltip>;
  }
  return icons[icon](otherprops);
};

export default TSIcon;
